module.exports = __webpack_public_path__ + "img/socialCenterBottom.aa672076.png";